const initProductPage = () => {
  document.addEventListener('variant:changed', (e) => {
    const hiddenAddToCartButton = document.querySelector('.product-variant-id');
    // add variant id to the query string
    const url = new URL(window.location.href);
    url.searchParams.set('variant', e.detail.variantId);
    if (hiddenAddToCartButton) {
      hiddenAddToCartButton.value = e.detail.variantId;
    }
    window.history.replaceState({}, '', url);
  });

  const interval = setInterval(() => {
    const reviewSection = document.querySelector('#stamped-main-widget');

    // we need to have a max interval, as the review section might not be found
    let maxInterval = 20;

    if (reviewSection) {
      clearInterval(interval);
      reviewSection.addEventListener('click', (e) => {
        // if the target is a link with the data attribute aria-label="Next page", scroll to the top of the review section
        // we need to have the event listener on the reviewSection, as the link inside it changed when the user clicks it
        if (e.target.getAttribute('aria-label') === 'Next page') {
          reviewSection.scrollIntoView({ behavior: 'smooth' });
        }
      });

      return;
    }

    maxInterval--;
    if (maxInterval === 0) {
      clearInterval(interval);
    }
  }, 1000);
};

document.addEventListener('DOMContentLoaded', initProductPage);
